<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "CLIENTS.CLIENTS" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="center p-24 pb-56">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center">
        <div class="h1 pr-16">Clientes</div>
        <button
            mat-icon-button
            color="accent"
            (click)="mostrarFiltros = !mostrarFiltros"
        >
            <mat-icon color="secondary">filter_list</mat-icon>
        </button>
    </div>


    <app-searchbox
    *ngIf="clientes"
    class="mb-16"
    [hidden]="!mostrarFiltros"
    [estados]="estados"
    [clientes]="clientes"
    (filtrarCliente)="filtrar($event)"
    >
    </app-searchbox>


    <!-- div class="content p-24" fusePerfectScrollbar -->
        <app-tabla-clientes
            *ngIf="clientes"
            [clientes]="clientes"
            (buscarMas)="buscarClientes($event)"
            [totalRegistros]="totalRegistros"
        ></app-tabla-clientes>
    <!-- /div -->

</div>
</div>
    <!-- / CONTENT -->
</div>
<button
    *ngIf="esSupervisor"
    mat-fab
    class="accent"
    id="agregar-cliente-button"
    (click)="nuevoCliente()"
    aria-label="Nuevo cliente"
    [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
>
    <mat-icon>add</mat-icon>
</button>
